import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { tv } from 'tailwind-variants';
import { useSlots, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModalFooter',
    props: {
        direction: { default: 'column' }
    },
    setup(__props) {
        const props = __props;
        const slots = useSlots();
        // 슬롯이 존재하는지 확인
        const hasSlotContent = computed(() => !!slots.default);
        const modalFooter = tv({
            base: 'align-center flex shrink-0 justify-center gap-8',
            variants: {
                direction: {
                    row: 'desktop:flex-row flex-col-reverse',
                    column: '',
                },
                hasSlot: {
                    true: 'desktop:px-40 desktop:pt-28 desktop:pb-40 px-16 pb-32 pt-20',
                    false: 'min-h-56',
                },
            },
            defaultVariants: {
                direction: 'row',
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_unref(modalFooter)({ direction: props.direction, hasSlot: hasSlotContent.value }))
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
